import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import {
  AssistantResolveRequest,
  AssistantResolveResponse,
  AssistantResolveStatus
} from './models';

@Injectable({
  providedIn: 'root'
})
export class AssistantActionService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/assistant`;

  resolveIntent(request: AssistantResolveRequest): Observable<AssistantResolveResponse> {
    return this.http.post<AssistantResolveResponse>(`${this.baseUrl}/resolve`, request).pipe(
      catchError((error) => {
        console.error('Assistant resolve failed:', error);
        return of(this.buildFallbackFailure('Unable to resolve voice action'));
      })
    );
  }

  private buildFallbackFailure(error: string): AssistantResolveResponse {
    return {
      status: 'error' as AssistantResolveStatus,
      actions: [],
      replyText: '',
      error
    };
  }
}
